<pcp-customer-select
  *ngIf="isMultiTenant"
  fxFlexAlign="center"
  [value]="permissions.selectedCustomer | async"
  (valueChange)="permissions.setSelectedCustomer($event)"
></pcp-customer-select>
